import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';

export const Root = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
  margin: '10px 0'
});

export const Step = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'relative',
  width: '100%'
});

export const LineContainer = styled('div')({
  position: 'absolute',
  top: '50%',
  left: 0,
  right: 0,
  height: 2,
  display: 'flex'
});

export const Line = styled('div')(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.palette.grey[400]
}));

export const StepNumber = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 'bold',
  marginTop: theme.spacing(0.5),
  padding: '0 4px'
}));

export const SpacedTexts = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start'
});

export const IconContainer = styled('div')({
  padding: '0 2px',
  display: 'flex',
  justifyContent: 'center'
});

export const OriginAddressContainer = styled(Typography)({
  maxWidth: '50%',
  display: 'flex',
  textAlign: 'left',
  marginLeft: '4px',
  wordBreak: 'break-word'
});

export const DestinationAddressContainer = styled(Typography)({
  maxWidth: '50%',
  display: 'flex',
  textAlign: 'right',
  marginRight: '4px',
  wordBreak: 'break-word'
});

export const iconFontStyle = {
  fontSize: '16px'
};
